module.exports = __webpack_public_path__ + "img/symbol_11.ed6694cc.png";